import { Row } from '../layout';
export default Row;



/** WEBPACK FOOTER **
 ** ./components/row/index.js
 **/